// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"

import ThemeController from "./theme_controller"
application.register("theme", ThemeController)

import ClipboardController from "./clipboard_controller"
application.register("clipboard", ClipboardController)

import ZoomImagesController from "./zoom_images_controller"
application.register("zoom-images", ZoomImagesController)
